var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#15206b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.66699 5.83325h3.33331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.66699 9.16675h3.33331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.66699 12.5h3.33331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.65845 17.3083-2.59166-1.2916c-.11523-.0573-.24221-.0871-.37089-.0871-.12867 0-.25555.0298-.37079.0871l-1.75832.875c-.12686.0639-.26792.0943-.40985.0884-.14193-.006-.28003-.0481-.4011-.1224s-.22108-.1783-.29063-.3022-.10638-.2634-.10681-.4055v-11.98333c0-.44203.17562-.86596.48818-1.17852s.73646-.48815 1.17849-.48815h10.00003c.442 0 .866.17559 1.1786.48815.3125.31256.488.73649.488 1.17852v11.98333c-.0011.1409-.0379.2792-.107.402-.0691.1229-.1682.2261-.2881.3002-.1198.0741-.2566.1166-.3973.1235-.1408.0069-.281-.022-.4075-.084l-1.7583-.875c-.1153-.0573-.2423-.0871-.3709-.0871-.1287 0-.2556.0298-.3708.0871l-2.5917 1.2916c-.1152.0573-.2422.0871-.3709.0871-.12864 0-.25552-.0298-.37075-.0871z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/order.b41856835f98030b32b8fa9c34ff4ba9.svg";